import { t } from '@lingui/core/macro'

export const initialValues = {
  search: '',
  dealers: [],
  produtos: [],
  permissoes: [],
  tipoUsuario: null,
  somenteAtivos: true
}

export const CONST_ROOT_FOLDER = 'BIBLIOTECA_VIRTUAL!TECSINAPSE!'
export const CONST_ROOT_NAME = t`Biblioteca`

export const VisibilidadePasta = {
  PUBLICA: { label: 'Pública', value: true },
  PRIVADA: { label: 'Privada', value: false }
} as const

export const maxSize = 10000000000
